import { EntityTypes } from "./definitions";
import { ASSET_TYPES } from "../vlx/consts";
import AssetEntity from "./assetEntity";

export default class AnimationEntity extends AssetEntity {
    constructor() {
        super(EntityTypes.ANIMATION, ASSET_TYPES.animation);
    }
}
